import jq from "jquery";
export default {
  requestCodeImg: function(url,params){
    return process.env.VUE_APP_API_PREFIX + url + "?codeStr=" + encodeURIComponent(params)
  },
  requestWithToken: function (url, params, type, dataType) {
    var token = window.localStorage.getItem("accessToken");
    var tokenType = window.localStorage.getItem("tokenType");
    jq.ajax({
      type: type ? type : 'post',
      url: process.env.VUE_APP_API_PREFIX + url,
      headers: {
        Authorization: tokenType + " " + token,
        Version: process.env.VUE_APP_VERSION,
      },
      data: params,
      dataType: dataType ? dataType : 'json',
      success: function (res) {
        resolve(res);
      },
      error: function (err) {
        reject(err);
      }
    });
  },
}